





















































import { Component, Vue, Prop } from 'vue-property-decorator';
import _kebabCase from 'lodash.kebabcase';
import { IGameItemForSaleByGala } from '~/store/games/types';
import { ISortOption } from '~/store/types';
import StoreItemCard from '~/components/Store/StoreItemCard.vue';

@Component({
  components: {
    StoreItemCard,
  },
})
export default class ItemList extends Vue {
  @Prop(Array) readonly data!: IGameItemForSaleByGala[];
  @Prop(String) readonly listTitle!: string;
  @Prop(Function) readonly viewAll!: () => void;
  @Prop({ type: Boolean, default: false }) readonly toMint!: boolean;
  @Prop({ type: Boolean, default: false }) readonly showNewLabel!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly shouldRowColumnsMatch!: boolean;

  sortBy: ISortOption = {
    title: 'price high to low',
    property: 'avgPrice',
    direction: -1,
  };

  get listId() {
    return _kebabCase(this.listTitle);
  }

  get itemsForSale() {
    return this.data;
  }

  get itemListLength() {
    return this.itemsForSale.length;
  }

  get showViewAllCard() {
    return (
      this.shouldRowColumnsMatch &&
      this.viewAll &&
      (this.itemListLength === 5 ||
        (this.itemListLength === 3 &&
          (this.$vuetify.breakpoint.width < 600 ||
            this.$vuetify.breakpoint.width > 1449)) ||
        this.itemListLength === 1 ||
        (this.itemListLength === 2 && this.$vuetify.breakpoint.width >= 600))
    );
  }
}
